export type { AppStrings } from './types.js';
export type { Locale, LocaleMeta } from './locales.js';
export { SUPPORTED_LOCALES, LOCALE_CODES, RTL_LOCALES } from './locales.js';
export { normalizeLocale, resolveLocale } from './normalize.js';
export { plural } from './plural.js';
export type { PluralForms } from './plural.js';
export { isRtlText, hasUnsupportedScript } from './render.js';

import type { AppStrings } from './types.js';
import type { Locale } from './locales.js';
import { BUNDLES } from './locales.js';
import { en } from './en.js';

/**
 * Строки интерфейса для выбранного языка. Для языков без готового перевода
 * (нет в BUNDLES) — безопасный fallback на английский.
 */
export function getStrings(locale: Locale): AppStrings {
  return BUNDLES[locale] ?? en;
}
